import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import { trackGAEvent } from '@/utility/analytics';
import { t } from '@/utility/localization';
import { CM_PORTAL_MONEY_PAGE_ROUTE } from '@/utility/routesHelper';

import { useAuthContext } from '@/contexts/AuthContext';

import getConstants from '@/pages/portal/constants';

import useCampaignAnnouncements from './useCampaignAnnouncements';

export const useAnnouncementsModal = ({ activeCommunity }) => {
  const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] =
    useState(false);
  const { ANNOUNCEMENT_MODAL_PROPS } = getConstants();
  const router = useRouter();
  const { isDemoUser } = useAuthContext();
  const {
    campaignAnnouncementsSeenData,
    setHaveSeenAnnouncement,
    loading: campaignAnnLoading
  } = useCampaignAnnouncements();

  const closeAnnouncementModal = () => {
    setIsAnnouncementModalOpen(false);
    trackGAEvent('announcement_gift_modal_closed', {
      communityId: activeCommunity?._id
    });
    setHaveSeenAnnouncement('giftModal', activeCommunity._id);
  };

  const announcementModalPrimaryCta = () => {
    closeAnnouncementModal();
    trackGAEvent('announcement_gift_modal_cta_clicked', {
      communityId: activeCommunity._id
    });
    router.push(`${CM_PORTAL_MONEY_PAGE_ROUTE}?month=1&year=2024`);
  };

  useEffect(() => {
    if (!isDemoUser && activeCommunity && !campaignAnnLoading) {
      const { firstDollarCampaign, feb2024CampaignRewardReceived } =
        activeCommunity.config || {};

      // If community did not receive any rewards, return
      if (!feb2024CampaignRewardReceived && !firstDollarCampaign) return;

      const show = !campaignAnnouncementsSeenData?.giftModal?.includes(
        activeCommunity._id
      );
      if (show) {
        setIsAnnouncementModalOpen(true);
        trackGAEvent('announcement_gift_modal_shown', {
          communityId: activeCommunity._id
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDemoUser, activeCommunity, campaignAnnLoading]);

  return {
    isAnnouncementModalOpen,
    campaignAnnouncementsSeenData,
    setHaveSeenAnnouncement,
    closeAnnouncementModal,
    modalProps: {
      show: isAnnouncementModalOpen,
      onClose: closeAnnouncementModal,
      primaryCta: {
        text: t('start-earning'),
        onClick: announcementModalPrimaryCta
      },
      ...ANNOUNCEMENT_MODAL_PROPS
    }
  };
};
